export default __webpack_public_path__ + "static/media/Hair_16_F_C3.ee155422.svg";